<app-header></app-header>

<section id="contacto" class="bg-grey reset-section-pad2" *ngIf="isDataLoaded">

    <div class="container">

          <div class="row" >
            <app-title-section
                data-aos="fade-right" data-aos-duration="1500"
                [titleTxt]="contactoData.titleTxt!"
            >
            </app-title-section>
         </div>

           <div class="row equipo-int-blq">

              <div class="col-lg-12 equipo-int-blq-inner-img" data-aos="fade-right" data-aos-duration="1500">

                <img class="img-fluid" src="https://{{contactoData.imgBigUrl}}" alt="{{contactoData.imgBigAlt}}">
                    <div class="int-showcase__footer bg-grey"></div>
               </div>   
        
              <div class="col-lg-8 mt-5 equipo-int-blq-inner-text mb-5" [innerHTML]="contactoData.addressText">

               </div> 

         </div>


          <div class="row" >
             <div class="col-lg-12 head-tit">
                <app-title-section
                data-aos="fade-right" data-aos-duration="1500"
                [titleTxt]="contactoData.locationTitle!"
            >
            </app-title-section>        
             </div>   
         </div>


         <div class="row" >
             <div class="col-lg-12 mapa">
                <div class="mapouter">
                <div class="gmap_canvas">
                <iframe width="734" height="500" [src]="mapURI" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
                </div>
                </div>
                  
             </div>   
         </div>


     </div><!-- fin container-->

</section>


<app-footer-main></app-footer-main>
